import dynamic from 'next/dynamic';
import {createTranslator, type AbstractIntlMessages} from 'next-intl';
import withMainLayout from 'layouts/main';
import {pageMessagesProps} from 'helpers/i18n';
import HeroSection from '@/content/industry-real-estate-and-property-management/hero';
import shared from '../messages/en/shared.json';
import industryRealEstate from '../messages/en/industryRealEstate.json';

// Dynamic Content Components import
const FeaturesSection = dynamic(
  () => import('@/content/industry-real-estate-and-property-management/features-section'),
  {loading: () => null}
);
const SplitFeaturesSection = dynamic(
  () => import('@/content/industry-real-estate-and-property-management/split-features-section'),
  {loading: () => null}
);
const CustomerStoriesSection = dynamic(
  () => import('@/content/industry-real-estate-and-property-management/customer-stories-section'),
  {loading: () => null}
);
const FaqSection = dynamic(
  () => import('@/content/industry-real-estate-and-property-management/faq-section'),
  {loading: () => null}
);
const PrefooterSection = dynamic(
  () => import('@/content/industry-real-estate-and-property-management/prefooter-section'),
  {loading: () => null}
);

const IndustryRealEstateAndPropertyManagementPage = () => (
  <>
    <HeroSection />
    <FeaturesSection />
    <SplitFeaturesSection />
    <CustomerStoriesSection />
    <FaqSection />
    <PrefooterSection />
  </>
);

type PageMessagesProps = {
  locale: string;
  messages: AbstractIntlMessages;
};

const seoMetas = (props: PageMessagesProps) => {
  const t = createTranslator({
    locale: props.locale,
    messages: props.messages
  }) as (key: string) => string;

  return {
    title: t('industryRealEstate.seo.title'),
    description: t('industryRealEstate.seo.description'),
    canonical: t('industryRealEstate.seo.canonical')
  };
};

export const messagesForIntl = {shared, industryRealEstate};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}

export default withMainLayout(IndustryRealEstateAndPropertyManagementPage, seoMetas as never);
